import { Injectable } from '@angular/core';
import {DetailComponent} from "../modules/content/detail/detail.component";
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<DetailComponent> {

    constructor(private OBJ_translate_service: TranslateService)
    {
    }

    canDeactivate(
        OBJ_detail_component: DetailComponent,
        OBJ_current_route: ActivatedRouteSnapshot,
        OBJ_current_state: RouterStateSnapshot,
        OBJ_next_state?: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        if (OBJ_detail_component.hasUnsavedChanges())
        {
            return confirm(this.OBJ_translate_service.instant("oDetail.sUnsavedChanges"));
        } // end if

        return true;
    }
}
